if (!customElements.get('video-gallery-media')) {
  class VideoGalleryMedia extends HTMLElement {
    constructor() {
      super();
      this._boundHandlePlay = this.handlePlay.bind(this);
      this._boundOnPlay = this.onPlay.bind(this);
      this._boundOnPause = this.onPause.bind(this);
      this._boundOnEnded = this.onEnded.bind(this);
    }

    get video() {
      return this.querySelector('video');
    }

    get videoContainer() {
      return this.querySelector('[hidden]') || this.lastElementChild;
    }

    connectedCallback() {
      this.addEventListener('click', this._boundHandlePlay);

      const video = this.video;
      if (video) {
        video.addEventListener('play', this._boundOnPlay);
        video.addEventListener('pause', this._boundOnPause);
        video.addEventListener('ended', this._boundOnEnded);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._boundHandlePlay);

      const video = this.video;
      if (video) {
        video.removeEventListener('play', this._boundOnPlay);
        video.removeEventListener('pause', this._boundOnPause);
        video.removeEventListener('ended', this._boundOnEnded);
      }
    }

    handlePlay(event) {
      if (event.target.closest('video')) return;
      
      event.preventDefault();
      event.stopPropagation();

      if (this.hasAttribute('playing')) {
        this.pause();
      } else {
        this.play();
      }
    }

    play() {
      const videoContainer = this.videoContainer;
      if (videoContainer) {
        videoContainer.hidden = false;
      }
      
      const video = this.video;
      if (video) {
        video.play().catch(error => {
          console.warn('Video playback failed:', error);
        });
      }
    }

    pause() {
      const video = this.video;
      if (video) {
        video.pause();
      }
    }

    onPlay() {
      document.querySelectorAll('video-gallery-media[playing]').forEach(media => {
        if (media !== this) {
          media.pause();
        }
      });

      this.setAttribute('playing', '');
      
      const videoContainer = this.videoContainer;
      if (videoContainer) {
        videoContainer.hidden = false;
      }
    }

    onPause() {
      this.removeAttribute('playing');
    }

    onEnded() {
      this.removeAttribute('playing');
      
      const videoContainer = this.videoContainer;
      if (videoContainer) {
        videoContainer.hidden = true;
      }
      
      const video = this.video;
      if (video) {
        video.currentTime = 0;
      }
    }
  }

  customElements.define('video-gallery-media', VideoGalleryMedia);
}
